import { Col, Row } from 'antd';
import classNames from 'classnames/bind';
import Slider from 'react-slick';
import styles from './CustomerFeedbackHome.module.scss';

const cx = classNames.bind(styles);

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
};

export default function CustomerHome({ data }) {
    return (
        <div className={cx('root')}>
            <div>
                <div className={cx('heading')}>
                    <h3>Customers' feelings</h3>
                </div>

                <div className={cx('sliderBox')}>
                    <Row justify="center">
                        <Col span={24}>
                            <Slider {...settings}>
                                {data &&
                                    data.length > 0 &&
                                    data.map((item) => (
                                        <div key={item.id} className={cx('sliderItem')}>
                                            <div className={cx('sliderImg')}>
                                                <img src={item.avatar} alt={item.fullname} />
                                            </div>

                                            <div className={cx('sliderContent')}>
                                                <h3>{item.fullname}</h3>
                                            </div>
                                            <div className={cx('sliderQuote')}>
                                                <p>{item.feedback_content}</p>
                                            </div>
                                        </div>
                                    ))}
                            </Slider>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}
